import bidManager from './bidManager';
import logger from './logger';
const BIDDER_TIMEOUT = 1500;
const initHtl = () => {
    if (window.htlbid) {
        return;
    }
    window.htlbid = { cmd: [] };
};
const HtlbidCreate = ({ bidderTimeout = BIDDER_TIMEOUT, bidders = [], adTargeting = [], }) => {
    let slots = [];
    const hasMarketingConsent = /(^|;)\s*CookieConsent=[^;]*marketing:true/.test(document.cookie);
    const consentBidders = hasMarketingConsent ? bidders : [];
    const targetingArray = hasMarketingConsent ? adTargeting : [];
    targetingArray.push(['advelvet', [String(Math.floor(Math.random() * 20) + 1)]]);
    initHtl();
    bidManager.init(consentBidders);
    const addPlacement = (opt) => {
        logger.log('addPlacement, network:', opt.network, 'targeting:', targetingArray);
        if (!opt.network) {
            throw new Error('"network" can not be empty string');
        }
        const slotSizes = opt.sizes || [];
        const targeting = targetingArray.concat(opt.targetingArray || []);
        let adRequestSent = false;
        const sendAdRequest = () => {
            const slot = getSlot();
            if (adRequestSent || !slot) {
                return undefined;
            }
            window.htlbid?.cmd.push(() => {
                window.htlbid?.pubads().refresh(slots);
                adRequestSent = true;
            });
        };
        destroySlot();
        window.htlbid?.cmd.push(() => {
            if (!window.htlbid) {
                return;
            }
            const getOutOfPageId = () => targeting.some(x => x[0] === 'interstitial') && window.htlbid
                ? window.htlbid.enums.OutOfPageFormat.INTERSTITIAL
                : opt.divId;
            const slot = slotSizes.flat().includes('Out-of-page')
                ? window.htlbid.defineOutOfPageSlot(opt.network, getOutOfPageId())
                : window.htlbid.defineSlot(opt.network, slotSizes, opt.divId);
            for (let i = 0; i < targeting.length; i++) {
                const target = targeting[i];
                if (target.length === 2) {
                    slot.setTargeting(target[0], target[1]);
                }
            }
            slot.setCollapseEmptyDiv(true).addService(window.htlbid.pubads());
            slots = [slot];
            window.htlbid.display(slot);
            refreshPlacement();
        });
        if (consentBidders?.length && /(^|;\s*)__gads=/.test(document.cookie)) {
            const numberSizes = slotSizes.filter(sizes => Array.isArray(sizes) &&
                !sizes.some((size) => typeof size === 'string'));
            numberSizes.length &&
                bidManager.requestBids(opt.divId, opt.network, numberSizes, consentBidders, sendAdRequest);
            setTimeout(sendAdRequest, bidderTimeout);
        }
        else {
            sendAdRequest();
        }
    };
    const refreshPlacement = () => {
        const slot = getSlot();
        if (!slot) {
            return;
        }
        const id = getSlotElementId();
        if (!id) {
            return;
        }
        window.htlbid?.cmd.push(() => {
            window.htlbid?.display(id);
            window.htlbid?.pubads().refresh(slots);
        });
    };
    const addEventListener = (eventType, listener) => {
        window.htlbid?.cmd.push(() => {
            window.htlbid?.pubads().addEventListener(eventType, listener);
        });
    };
    const getSlot = () => slots[0];
    const destroySlot = () => {
        window.htlbid?.cmd.push(() => {
            window.htlbid?.destroySlots(slots);
        });
        slots = [];
    };
    const getSlotElementId = () => getSlot()?.getSlotElementId();
    return {
        addPlacement,
        addEventListener,
        getSlot,
        destroySlot,
        refreshPlacement,
        getSlotElementId,
    };
};
export default HtlbidCreate;
//# sourceMappingURL=htlbid.js.map